import styled from "styled-components";

export const ChatMessagesWrapper = styled.div`
  .norecord {
    margin-top: 20px;
  }
  .messagesContainer {
    margin-top: 20px;
    width: 100%;
    border: 1px solid black;
    border-radius: 4px;
    height: calc(100vh - 120px);
    padding: 10px;
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    overflow-y: scroll;
  }
  .messageBox {
    display: flex;
    flex-direction: row;
    gap: 10px;
    max-width: 70%;
    .senderImage {
      height: 32px;
      width: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
    .messageAndSenderInfo {
      display: flex;
      flex-direction: column;
      .sender {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        color: rgb(119, 119, 119);
        max-width: 320px;
      }
      .message {
        width: fit-content;
        background: rgb(241, 241, 241);
        padding: 5px;
        border-radius: 0px 10px 10px;
        font-size: 18px;
        color: rgb(102, 102, 102);
        line-height: 22px;
        letter-spacing: 0.02em;
      }
      .mediaBox {
        background: rgb(241, 241, 241);
        border-radius: 0px 10px 10px;
        max-width: max-content;
        padding: 5px;
        margin-bottom: 5px;
      }
      .messageImage {
        width: 100%;
        max-width: 320px;
        object-fit: cover;
        border-radius: 5px;
      }
    }
  }
  .msg-time-container {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .msg-time-border {
    z-index: -1;
    position: absolute;
    border: 1px dashed #e5e5e5;
    width: 100%;
    top: 12px;
  }
  .msg-time {
    background: #fff;
    width: 145px;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
  }
  .fileMessage {
    width: 320px;
    span {
      display: block;
      font-style: normal;
      font-weight: 400;
      padding: 10px;
      font-size: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 310px;
    }
    .fileName {
      margin-bottom: 10px;
    }
    .downloadButton {
      background-color: transparent;
      width: 100%;
      text-align: center;
      color: rgb(101, 121, 244);
      border-top: 1px solid rgb(102, 102, 102);
      border-radius: 0;
    }
  }
  .messages-loader {
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    color: rgb(119, 119, 119);
    width: 100%;
    text-align: center;
  }
  .message a {
    color: #607afc;
  }
  @media (max-width: 768px) {
    .fileMessage {
      width: auto;
      span {
        max-width: 200px;
      }
    }
  }
`;
